import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const Table = ({ headings, rows }) => {
  return (
    <table className="form-table">
      <thead>
        <tr>
          {headings.map((heading, idx) => (
            <th key={idx}>{heading}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {(rows || []).map((row, idx) => (
          <tr key={idx}>
            {(row.cells || []).map((cell, index) => (
              <td key={index}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.arrayOf(PropTypes.shape({ cell: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]) })),
};

export default Table;
